export const theme = {
  textMuted: '#4b5563',
  brand: '#1d4ed8',
  edge: {
    default: '#9ca3af',
    calls: '#334155',
    wait: '#8b5cf6',
    ifTrue: '#22c55e',
    ifFalse: '#ef4444',
    parallel: '#0ea5e9',
    runsOn: '#059669',
    dq: '#10b981',
    reconSrc: '#f59e0b',
    reconTgt: '#ef4444',
  },
};

export function edgeColorByRelation(rel?: string, ctx?: string) {
  const r = (rel || '').toLowerCase();
  const c = (ctx || '').toLowerCase();
  const edge = theme.edge; // FIX

  if (r.includes('wait')) return edge.wait;
  if (r.includes('parallel')) return edge.parallel;
  if (r.includes('runs_on') || r.includes('cluster')) return edge.runsOn;
  if (r.includes('dq_checks')) return edge.dq;
  if (r.includes('recon_source')) return edge.reconSrc;
  if (r.includes('recon_target')) return edge.reconTgt;
  if (r.includes('if')) return c.includes('true') ? edge.ifTrue : edge.ifFalse;
  if (r.includes('writes') || r.includes('triggers') || r.includes('call')) return edge.calls;
  return edge.default;
}

export function edgeLabel(rel?: string, ctx?: string) {
  const r = (rel || '').toLowerCase();
  const c = (ctx || '').toUpperCase();
  if (r.includes('if')) return c ? `if:${c}` : 'if';
  if (r.includes('wait')) return 'wait';
  if (r.includes('parallel')) return 'parallel';
  if (r.includes('runs_on') || r.includes('cluster')) return 'runs_on';
  if (r.includes('dq_checks')) return 'dq_checks';
  if (r.includes('recon_source')) return 'recon_source';
  if (r.includes('recon_target')) return 'recon_target';
  if (r.includes('writes')) return 'writes';
  if (r.includes('triggers')) return 'triggers';
  if (r.includes('call')) return 'calls';
  return '';
}
